import { render } from "./document.vue?vue&type=template&id=04882a53&ts=true"
import script from "./document.vue?vue&type=script&scoped=true&lang=ts"
export * from "./document.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__